import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { IntlProvider } from 'react-intl'
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter } from 'react-router-dom'
import { queryClient } from '../lib/queryClient'
import { AuthProvider } from '../providers/Auth/Auth'
import { NotificationContextProvider } from './Notification'

type AppProvidersProps = {
  children: React.ReactNode
  locale: string
  messages: Record<string, string>
}

export function AppProviders({
  children,
  locale,
  messages,
}: AppProvidersProps) {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <IntlProvider locale={locale} messages={messages} defaultLocale="en">
          <BrowserRouter>
            <AuthProvider>
              <div className="font-sans min-h-screen flex flex-col mydra-base-layout">
                <NotificationContextProvider>
                  {children}
                </NotificationContextProvider>
              </div>
            </AuthProvider>
          </BrowserRouter>
        </IntlProvider>
        {import.meta.env.DEV && <ReactQueryDevtools />}
      </QueryClientProvider>
    </HelmetProvider>
  )
}
